module.exports = __webpack_public_path__ + "ccb6a722d5339efe6a884e60f64ac863.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/logout.png
 ** module id = 1396
 ** module chunks = 0
 **/